<template>
  <div class="tab-pane fade show active" id="tab1" role="tabpanel" aria-labelledby="tab-1">
    <div class="form-row">
      <div class="col-md-6">
        <div class="innerbox">
          <h2>Projekt-Stammdaten</h2>
          <div class="inrbox formlft pb-2">
            <form>
              <div class="form-row">
                <label for="inputEmail3" class="col-sm-6 col-md-6 col-lg-5 col-xl-3">Kunde</label>
                <div class="col-sm-6">
                  <input type="text" v-model="project.company_name" class="form-control input-style" id="inputEmail3"  readonly>
                </div>
              </div>
              <div class="form-row">
                <label class="col-sm-6 col-md-6 col-lg-5 col-xl-3" for="name">Projektname</label>
                <div class="col-sm-6">
                  <input type="text" id="name" v-model="project.name" class="form-control input-style">
                </div>
              </div>
              <div class="form-row">
              <label class="col-sm-6 col-md-6 col-lg-5 col-xl-3" for="shortname">Kurzbezeichnung</label>
              <div class="col-sm-6">
                <input type="text"  id="shortname" v-model="project.shortname" class="form-control input-style" :class="{'is-invalid': project.shortname && project.shortname.length > 10}">
              </div>
                <div class="col-sm-6 col-md-6 col-lg-5 col-xl-3 pt-1 font-10 pr-0" v-if="project.shortname && project.shortname.length > 10">
                  <span class="text-danger">Maximal 10 Zeichen erlaubt</span>
                </div>
            </div>
              <div class="form-row">
              <label class="col-sm-6 col-md-6 col-lg-5 col-xl-3" for="number">Projektnummer</label>
              <div class="col-sm-6">
                <input type="text" id="number" v-model="project.number" class="form-control input-style" >
              </div>
            </div>   <div class="form-row">
              <label class="col-sm-6 col-md-6 col-lg-5 col-xl-3" for="street">Straße / Nr.</label>
              <div class="col-sm-6">
                <input type="text" v-model="project.street" id="street" class="form-control input-style" >
              </div>
            </div>   <div class="form-row">
              <label class="col-sm-6 col-md-6 col-lg-5 col-xl-3" for="zip">PLZ</label>
              <div class="col-sm-6">
                <input type="text" id="zip" v-model="project.zipcode" class="form-control input-style" >
              </div>
            </div>   <div class="form-row">
              <label class="col-sm-6 col-md-6 col-lg-5 col-xl-3" for="city">Ort</label>
              <div class="col-sm-6">
                <input type="text" id="city" v-model="project.city" class="form-control input-style">
              </div>
            </div>
              <div class="form-row">
                <label class="col-sm-6 col-md-6 col-lg-5 col-xl-3">Land</label>
                <div class="col-sm-6">
                 <countries-select-input/>
                </div>
              </div>
              <div class="form-row">
                <label class="col-sm-6 col-md-6 col-lg-5 col-xl-3" for="Bauherr">Bauherr</label>
                <div class="col-sm-6">
                  <input  id="Bauherr" type="text" @input="setConst" :value="project.constructor" class="form-control input-style">
                </div>
              </div>
              <div class="form-row">
                <label class="col-sm-6 col-md-6 col-lg-5 col-xl-3" for="cons">Projektverantwortlicher</label>
                <div class="col-sm-6">
                  <input type="text" id="cons" v-model="project.manager" class="form-control input-style">
                </div>
              </div>
              <div class="form-row">
                <label  class="col-sm-6 col-md-6 col-lg-5 col-xl-3" for="des">Projektbeschreibung</label>
                <div class="col-sm-6">
                  <textarea id="des" v-model="project.description" class="form-control input-style mb-2"></textarea>
                </div>
              </div>


              <div class="form-row">
                <label class="col-sm-6 col-md-6 col-lg-5 col-xl-3" for="datepicker">Projektbeginn  </label>
                <div class="col-sm-6">
                  <div  class="d-flex date date-pick mr-2">
                    <span class="input-group-addon font1rem text-dark  mr-1"><i class="fa fa-calendar"></i></span>
                    <input id="datepicker" :value="proDate(project.startdate)" class="form-control font1rem input-style" data-date-format="dd.mm.yyyy">
                  </div>
                </div>
              </div>

              <div class="form-row">
                <label class="col-sm-6 col-md-6 col-lg-5 col-xl-3">Projekt deaktivieren </label>
                <div class="col-sm-6">
                  <div class="switch new">
                    <label class="w-100" for="status">
                      <input type="checkbox" v-model="project.status" :true-value="false" :false-value="true" id="status">
                      <span class="lever mr-0"></span>
                    </label>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="dokubtns">
            <span class="btninner">
              <button type="button" class="btn btn-red" data-dismiss="modal" @click="deleteProject(project.projectid)">
                Projekt löschen
              </button>
            </span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="innerbox prlogos pb-2">
          <h2>Projekt-Logos</h2>
          <div class="inrbox pb-4">
            <div class="row">
              <div class="col-md-6">
                <!--                  switch for set white logo    -->
                <div class="switch new d-inline pr-1">
                  <label class="mb-0" for="isActive_one">
                    <input type="checkbox" @change="uploadLogoOne($event,true)" id="isActive_one" :checked="project.logo1 != -2">
                    <span class="lever mr-0 mt-0"></span> <strong class="pl-1">Logo links</strong>
                  </label>
                </div>
                <div class="logowrap p-1 mt-2 shadow-none">
                  <img  ref="logo_one" id="logo_one" :src="logoOne" alt="logoOne" class="img-fluid border-0 logoImages">
                </div>
               <div class="form-group mb-0" v-visible="isLogoOne">
                <label for="logo1" class="custom-file-upload">
                  <i class="fa fa-cloud-upload"></i> Logo auswählen
                </label>
                <input id="logo1" @change="uploadLogoOne" type="file" accept="image/*"/>
               </div>
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="alaa" :true-value="1" :false-value="0"  v-model="project.use_as_customer_logo1" @change="project.useAsCustomerLogo1 = project.use_as_customer_logo1">
                  <label class="custom-control-label p-0" for="alaa">
                    <span class="pl-1"> Als Standard festlegen</span>
                  </label>
                </div>
              </div>
              <div class="col-md-6">
<!--                  switch for set white logo-->
                <div class="switch new pr-1">
                  <label class="d-inline" for="isActive_two">
                    <input type="checkbox" @change="uploadLogoTwo($event,true)" id="isActive_two" :checked="project.logo2 != -2">
                    <span class="lever mr-0 mt-0"></span>
                    <strong class="pl-1">Logo rechts</strong>
                  </label>
                </div>
                <div class="logowrap p-1 mt-2 shadow-none">
                  <img ref="logo_two" :src="logoTwo" alt="logoTwo" class="img-fluid logoImages">
                </div>
                <div class="form-group mb-0" v-visible="isLogoTwo">
                <label for="logo2" class="custom-file-upload">
                  <i class="fa fa-cloud-upload"></i> Logo auswählen
                </label>
                <input  id="logo2" @change="uploadLogoTwo" type="file" accept="image/*"/>
                </div>
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="alaa2" :true-value="1" :false-value="0"  v-model="project.use_as_customer_logo2" @change="project.useAsCustomerLogo2 = project.use_as_customer_logo2">
                  <label class="custom-control-label p-0" for="alaa2">
                    <span class="pl-1"> Als Standard festlegen</span>
                  </label>
                </div>
              </div>

              <div class="col-md-12">
                <div class="logolarge">
                  <label class="font1rem"><b>Projektbild</b> </label>
                  <div>
                    <img :src="projectImg" ref="project_photo" class="img-fluid w-100 img-thumbnail" alt="projectImage">
                  </div>
                  <label for="file-upload" class="custom-file-upload">
                    <i class="fa fa-cloud-upload"></i> Projektbild auswählen
                  </label>
                  <input ref="project_img" id="file-upload" @change="uploadProjectImage" type="file" accept="image/*"/>
                </div>
              </div>
            </div>
          </div>
          <div class="dokubtns text-right pt-3">
            <span class="btninner">
              <button type="button" class="btn btn-danger" @click="$router.push({ name: 'photo', params: { id: $route.params.id } } )">
                Abbrechen
              </button>
              <button type="button" @click="saveProjectDetails" class="btn btn-blue">
                {{$t('save')}}
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import axios from '../../../utils/axiosinstance'
import CountriesSelectInput from './CountriesSelectInput'
import { formatDate ,formatAsInputDate } from '../../common'
import {mapState} from 'vuex'
export default {
  name: 'general',
  components: {CountriesSelectInput},
  data(){
    return {
      pro_cons: '',
      pro_start_date: '',
      showLogoOne: true ,
      showLogoTwo: true ,
      projectCopy: {},
      isLogoOne: true,
      isLogoTwo: true,
      white_photo: null
    }
  },
  mounted () {
    this.setDatePicker();
  },
  computed : {
    ...mapState({
      project: state => state.appSettings.project,
      logoOne: state => state.appSettings.logoOne,
      logoTwo: state => state.appSettings.logoTwo,
      projectImg: state => state.appSettings.projectImage,
    }),

  },
  methods : {
    proDate: (date) => formatDate(date),
    setConst(event){
      this.project.constructor = event.target.value
    },

    setDatePicker () {
      let _this = this
      $('#datepicker').datepicker({
        autoclose: true,
        todayHighlight: true,
      }).on('changeDate', function(ev){
        _this.project.startdate = formatAsInputDate(ev.target.value);
      });
    },

    async deleteProject(projectid){
      let _this = this
      this.$confirm({
        message: 'Projekt wirklich löschen?',
        button: {
          no: 'Abbrechen',
          yes: 'Ja'
        },
        callback: confirm => {
          if (confirm) {
            _this.delProject(projectid)
          } else {
            console.log('UNCONFIRMED')
          }
        }
      })

    },

    async delProject(projectid){

      let url = `${process.env.VUE_APP_BASE_AMF_URL} deleteProject&token=${localStorage.sessiontoken}`
      let formData = {
        "methodName": "deleteProject",
        "serviceName": "ProjectdocuService",
        "parameters": [
          projectid
        ]}
      $('.spinner-cover').show()

      await axios.post( url, formData ).then( response => {
        $('.spinner-cover').hide()
        window.location.href = "/projects";

      }).catch(e => {
        console.log(e);
        this.$toast.error('Beim löschen ist ein Fehler aufgetreten.')
        $('.spinner-cover').hide()
      })


    },


    async saveProjectDetails(){
      if (this.project.shortname.length <= 10){
        await this.$store.dispatch('updateProjectDetails');
        await this.$router.push({name: 'photo', params: {id: this.$route.params.id}});
      }
    },


    async uploadLogoOne(event, isDisable = false){
      if (isDisable){
         this.white_photo = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAALiMAAC4jAXilP3YAAAAhdEVYdENyZWF0aW9uIFRpbWUAMjAxNTowMjoyNyAxNTozNTo0N4LUTpgAAAAkSURBVDhPY/z//z8DuYAJSpMFRjWTCEY1kwhGNZMIhqRmBgYAnKADJSVVsOwAAAAASUVORK5CYII="
        if (!this.projectCopy.projectid){
          this.projectCopy = {...this.project}
        }
        if (event.target.checked){
          // set Default logo here
          this.isLogoOne = true
          this.$refs.logo_one.setAttribute('src',this.logoOne)
          await this.$store.commit('setLogoOrProjectPhotos',{ type: 'logoOne', photo_id: this.projectCopy.logo1 })
        }else {
          // set white logo here ( disable logo )
          this.isLogoOne = false
          this.$refs.logo_one.setAttribute('src',this.white_photo)
          await this.$store.commit('setLogoOrProjectPhotos',{ type: 'logoOne', photo_id: -2 })
        }
      }
      else {
        let file = event.target.files[0];
        let src = window.URL.createObjectURL(file);
        this.$refs.logo_one.setAttribute('src',src)
        await this.uploadFile(file,'logo','logoOne');
      }
    },

    async uploadLogoTwo(event, isDisable = false){
      if (isDisable){
        this.white_photo = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAALiMAAC4jAXilP3YAAAAhdEVYdENyZWF0aW9uIFRpbWUAMjAxNTowMjoyNyAxNTozNTo0N4LUTpgAAAAkSURBVDhPY/z//z8DuYAJSpMFRjWTCEY1kwhGNZMIhqRmBgYAnKADJSVVsOwAAAAASUVORK5CYII="
        if (!this.projectCopy.projectid){
          this.projectCopy = {...this.project}
        }
        if (event.target.checked){
          // set Default logo here
          this.isLogoTwo = true
          this.$refs.logo_two.setAttribute('src',this.logoTwo)
          await this.$store.commit('setLogoOrProjectPhotos',{ type: 'logoTwo', photo_id: this.projectCopy.logo2 })
        }else {
          // set white logo here ( disable logo )
          this.isLogoTwo = false
          this.$refs.logo_two.setAttribute('src',this.white_photo)
          await this.$store.commit('setLogoOrProjectPhotos',{ type: 'logoTwo', photo_id: -2 })
        }
      }
      else {
        let file = event.target.files[0];
        let src = window.URL.createObjectURL(file);
        this.$refs.logo_two.setAttribute('src',src)
        await this.uploadFile(file,'logo','logoTwo');
      }
    },




    async uploadProjectImage(event){
      let file = event.target.files[0];
      let src = window.URL.createObjectURL(file);
      this.$refs.project_photo.setAttribute('src',src)
      await this.uploadFile(file,'deco','project');
    },


    async uploadFile (file,method,type) {
      let  formData = new FormData()
      formData.append('Upload',file);
      $('.spinner-cover').show();
      let url = `${process.env.VUE_APP_BASE_URL}backend/put?token=${localStorage.sessiontoken}&method=${method}&projectid=${this.$route.params.id}`
      await axios.post( url, formData,{
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('jwt') // Beispiel: Token wird aus dem LocalStorage geholt
          }
        }
      ).then( response => {
        $('.spinner-cover').hide()
        let payload = {photo_id : response.data , type : type}
        this.$store.commit("setLogoOrProjectPhotos",payload);
      }).catch(e => {
        console.log(e);
        this.$toast.error('Something went wrong!')
        $('.spinner-cover').hide()
      })
    },
  },
  watch: {
    logoOne: function (){
      if (this.project.logo1 == -2){
        this.isLogoOne = false
      }
    },
    logoTwo: function (){
      if (this.project.logo2 == -2){
        this.isLogoTwo = false
      }
    }
  }
}
</script>

<style scoped>
.inrbox .form-row label{
  font-size: 0.95rem;
}
input[type="file"] {
  display: none;
}
.custom-file-upload {
  margin-top: 10px;
  border: 1px solid #ccc;
  display: flow-root !important;
  padding: 6px 12px;
  cursor: pointer;
  width: 81%;
  border-radius: 4px;
  font-size: 14px;
}
.innerbox .form-row{
  margin-bottom: 7px;
}
.innerbox .form-row input[type="text"],.innerbox .form-row select{
  height: 30px;
  font-size: 0.96rem;
}
.custom-control-input:checked~.custom-control-label::before {
  background-color: #007bff;
  border: 0.5px solid #007bff;
}
</style>



// WEBPACK FOOTER //
// src/components/appSetting/components/General.vue